export default "__VITE_ASSET__BGLl14D6__"